import { render, staticRenderFns } from "./NoticeList.vue?vue&type=template&id=52012370&scoped=true"
import script from "./NoticeList.vue?vue&type=script&lang=js"
export * from "./NoticeList.vue?vue&type=script&lang=js"
import style0 from "./NoticeList.vue?vue&type=style&index=0&id=52012370&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52012370",
  null
  
)

export default component.exports